import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithHttpStatus } from '../services/baseQuery';

// Define a service using a base URL and expected endpoints
export const flightStore = createApi({
    reducerPath: 'flightStore',
    baseQuery: baseQueryWithHttpStatus,
    endpoints: (builder) => ({
        getDatasetView: builder.mutation({
            query: (body) => {
                return {
                    url: "aiDynamicDatasetService/getDatasetView/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        getFlightDocumentData: builder.mutation({
            query: (body) => {
                return {
                    url: "assetsDocument/getFlightDocumentData/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        createManualInstance: builder.mutation({
            query: (body) => {
                return {
                    url: "gptBlueLaunchpadExecute/createManualInstance/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        downloadFlightDocument: builder.mutation({
            query: (body) => {
                return {
                    url: "assetsDocument/downloadFlightDocument/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }), 
        createManualAgentInstance: builder.mutation({
            query: (body) => {
                return {
                    url: "gptBlueLaunchpadExecute/createManualAgentInstance/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }), 
    }),
})

export const {
    useGetDatasetViewMutation,
    useGetFlightDocumentDataMutation,
    useCreateManualInstanceMutation,
    useDownloadFlightDocumentMutation,
    useCreateManualAgentInstanceMutation,
} = flightStore;